module.exports = __webpack_public_path__ + "media/images/orelha-b2612c02ea13269ff613405cc4f4a637.png";